import { Dispatch, SetStateAction } from "react"

import { ChevronLeftIcon, ChevronRightIcon } from "@chakra-ui/icons"
import { ButtonGroup, IconButton } from "@chakra-ui/react"

import { setPageCount } from "utils/local-storage"

type PaginationProps = {
  pageStartIndex: number
  pageSize: number
  setPageStartIndex: Dispatch<SetStateAction<number>>
  itemsLength: number
}

const FeeMappingPagination = ({
  pageSize,
  pageStartIndex,
  setPageStartIndex,
  itemsLength,
}: PaginationProps) => {
  // Calculate if there's a next page

  const hasNextPage = pageSize <= itemsLength

  return (
    <ButtonGroup isAttached variant='outline'>
      {/* Previous Button */}
      <IconButton
        aria-label='previous page'
        icon={<ChevronLeftIcon h={7} w={7} />}
        onClick={() => {
          setPageStartIndex((x) => (x > 0 ? x - 1 : 0))
          setPageCount(`${pageStartIndex - 1}`)
        }}
        isDisabled={pageStartIndex === 0}
      />

      {/* Next Button */}
      <IconButton
        aria-label='next page'
        icon={<ChevronRightIcon h={7} w={7} />}
        onClick={() => {
          setPageStartIndex((x) => (hasNextPage ? x + 1 : x))
          setPageCount(`${pageStartIndex + 1}`)
        }}
        isDisabled={!hasNextPage}
      />
    </ButtonGroup>
  )
}

export default FeeMappingPagination
